import * as React from 'react';

import { LoadingIndicator } from '../Loading';

const LazyEmojiPicker = React.lazy(() => import('./EmojiPicker.lazy'));

/**
 * Component to pick an emoji from a searchable catalog without putting the full catalog on the
 * eager application path.
 */
export interface EmojiPickerProps {
    /** Callback when an emoji is selected. */
    onPick: (icon: string) => void;
    /**
     * Optional query to filter the emojis.
     * If a query is passed, a callback onChangeQuery should be passed to update the query.
     */
    query?: string;
    /** Callback when the query changes. */
    onChangeQuery?: (query: string) => void;
}

/**
 * Emoji catalog picker with an internal Suspense boundary so callers can import it normally.
 */
export function EmojiPicker(props: EmojiPickerProps) {
    return (
        <React.Suspense fallback={<EmojiPickerLoading />}>
            <LazyEmojiPicker {...props} />
        </React.Suspense>
    );
}

function EmojiPickerLoading() {
    return (
        <div className="flex h-80 w-80 items-center justify-center">
            <LoadingIndicator size="large" />
        </div>
    );
}
